import React from "react";
import "./CourseParticipantsType.css";

export default class CourseParticipantsType extends React.Component<
  { type: number; onChange: any; firstName: string; secondName: string },
  {}
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="course-participants-type-container">
          <div
            className={`course-participants-type-background course-participants-type-background-${this.props.type}`}
          ></div>
          <div className="course-type-inner-container">
            <div
              onClick={() => {
                this.props.onChange(1);
              }}
              className={
                this.props.type === 1
                  ? "course-participants-type-selected course-participants-type"
                  : "course-participants-type"
              }
            >
              {this.props.firstName}
            </div>
            <div
              onClick={() => {
                this.props.onChange(2);
              }}
              className={
                this.props.type === 2
                  ? "course-participants-type course-participants-type-selected"
                  : "course-participants-type"
              }
            >
              {this.props.secondName}
            </div>
          </div>
        </div>
      </>
    );
  }
}
